/**
 * 🚗 Vehicle People Flow Paywall
 * 
 * Componente de bloqueio para feature premium de análise demográfica
 * de pessoas em veículos. Exibido quando vehicle_people_flow_enabled = false.
 * 
 * Preço: R$ 100/mês
 */

import React from 'react';
import { PremiumFeatureBlock } from './PremiumFeatureBlock';
import { Users } from 'lucide-react';

export function VehiclePeopleFlowPaywall() {
  return (
    <PremiumFeatureBlock
      featureName="Fluxo de Pessoas em Veículos"
      description="Análise demográfica avançada de pessoas detectadas em veículos"
      price="R$ 100"
      priceUnit="por mês"
      icon={<Users className="w-16 h-16" />}
      benefits={[
        'Contagem automática de pessoas em veículos',
        'Distribuição por gênero (masculino/feminino)',
        'Análise por faixa etária (7 categorias)',
        'Gráfico de fluxo de pessoas por hora',
        'Média de pessoas por veículo',
        'Integração com todas as câmeras de veículos',
        'Relatórios demográficos detalhados',
        'Histórico completo de dados',
      ]}
    />
  );
}
